'use-strict';
const cssVars = require('css-vars-ponyfill').default;
cssVars({
    preserveVars: true,
    updateURLs: false,
    exclude: '[href*=fortawesome]',
});